<template>
    <footer class="footer">
        <div
            class="footer__inner d-flex flex-column flex-lg-row align-items-lg-center"
        >
            <div class="footer__head">
                <a
                    href="https://www.collegiumpharma.com/"
                    class="footer__logo"
                    target="_blank"
                >
                    <img
                        alt="Ironshore Logo"
                        src="@/assets/img/footer/Collegium_White.svg"
                        width="200"
                        height="60"
                    />
                </a>
            </div>
            <div class="footer__bottom">
                <nav class="footer__navigation">
                    <ul class="footer__menu">
                        <li class="footer__menu-item">
                            <a
                                href="https://www.collegiumpharma.com/contact-us/"
                                target="_blank"
                            >
                                Contact Us
                            </a>
                        </li>
                        <li class="footer__menu-item">
                            <a href="/site-map">Site Map</a>
                        </li>
                        <li class="footer__menu-item">
                            <a
                                href="https://www.collegiumpharma.com/terms-of-use/"
                                target="_blank"
                            >
                                Terms of Use
                            </a>
                        </li>
                        <li class="footer__menu-item">
                            <a
                                href="https://www.collegiumpharma.com/privacy-policy/"
                                target="_blank"
                            >
                                Privacy Policy
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="footer__copyright">
                    <p>
                        JORNAY PM<sup>®</sup> is a registered trademark of Ironshore Pharmaceuticals Inc., a wholly-owned subsidiary of Collegium Pharmaceutical, Inc. Collegium Pharmaceutical and the Collegium Pharmaceutical logo are registered trademarks of Collegium Pharmaceutical, Inc. The content on this site is intended for US providers only.
                    </p>
                    <p class="mb-0">
                   {{ copyrightText }}
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    computed: {
        copyrightText: function () {
            return '© 2026 Collegium Pharmaceutical, Inc. All rights reserved. PP-JNY-US-0444 10/26';
        },
        IP_NUMBER: function () {
            return 'PP-JNY-US-0444 10/26';
        },
    },
};
</script>

<style scoped></style>
